import React, { useMemo } from 'react';
import { useMapSettings } from 'ff/debrief/hooks';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import {
    AccordionSetting,
    AccordionSettingDetail,
    AccordionSettingSummary,
    AccordionSummaryValue,
    CustomMenuItem,
    SettingCheckbox,
    SettingLabel,
} from 'ff/debrief/components/map/settings/shared';

export const CulturalElementSettings = () => {
    const {
        currentSettings,
        settingsUI,
        toggleCulturalSetting,
        toggleAccordion,
    } = useMapSettings();
    const culturalElementsValue = useMemo(() => {
        const currentCultural = currentSettings?.culturalElements;

        const isAll =
            currentCultural?.major_roads &&
            currentCultural?.minor_roads &&
            currentCultural?.forests_parks &&
            currentCultural?.urban_areas &&
            currentCultural?.peaks_passes &&
            currentCultural?.points_of_interest &&
            currentCultural?.railroads;
        return isAll ? 'All' : 'Custom';
    }, [currentSettings?.culturalElements]);

    return (
        <CustomMenuItem>
            <AccordionSetting
                expanded={settingsUI?.accordionsExpanded?.cultural}
                onChange={() => toggleAccordion('cultural')}
            >
                <AccordionSettingSummary expandIcon={<ExpandMoreIcon />}>
                    <SettingLabel>Cultural Elements</SettingLabel>
                    <AccordionSummaryValue>
                        {culturalElementsValue}
                    </AccordionSummaryValue>
                </AccordionSettingSummary>
                <AccordionSettingDetail>
                    <MenuItem>
                        <SettingCheckbox
                            id="majorRoads"
                            displayName="Major Roads"
                            checked={
                                currentSettings?.culturalElements?.major_roads
                            }
                            onChange={() =>
                                toggleCulturalSetting('major_roads')
                            }
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            id="minorRoads"
                            displayName="Minor Roads"
                            checked={
                                currentSettings?.culturalElements?.minor_roads
                            }
                            onChange={() =>
                                toggleCulturalSetting('minor_roads')
                            }
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Railroads"
                            checked={
                                currentSettings?.culturalElements?.railroads
                            }
                            onChange={() => toggleCulturalSetting('railroads')}
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Power Lines"
                            checked={
                                currentSettings?.culturalElements?.power_lines
                            }
                            onChange={() =>
                                toggleCulturalSetting('power_lines')
                            }
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            id="urbanAreas"
                            displayName="Urban Areas"
                            checked={
                                currentSettings?.culturalElements?.urban_areas
                            }
                            onChange={() =>
                                toggleCulturalSetting('urban_areas')
                            }
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            id="forestParks"
                            displayName="Forest/National Parks"
                            checked={
                                currentSettings?.culturalElements?.forests_parks
                            }
                            onChange={() =>
                                toggleCulturalSetting('forests_parks')
                            }
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            id="pointsOfInterest"
                            displayName="Points of Interest"
                            checked={
                                currentSettings?.culturalElements
                                    ?.points_of_interest
                            }
                            onChange={() =>
                                toggleCulturalSetting('points_of_interest')
                            }
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            id="peaksPasses"
                            displayName="Peaks, Passes, and Cables"
                            checked={
                                currentSettings?.culturalElements?.peaks_passes
                            }
                            onChange={() =>
                                toggleCulturalSetting('peaks_passes')
                            }
                        />
                    </MenuItem>
                </AccordionSettingDetail>
            </AccordionSetting>
        </CustomMenuItem>
    );
};
